import React from 'react'
import Navbar from '../Navbar'
import { Link, NavLink } from "react-router-dom";
import Lottie from "lottie-react";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
    AccordionItemState,
} from 'react-accessible-accordion';
import Footer from '../Footer';
import BannerBg from "../../img/conversionBG.avif";
import WhyBg from "../../img/vitualCardBG.png";
import { FiMinus } from "react-icons/fi";
import { FiPlus } from "react-icons/fi";
import DownloadAfriPay from "../DownloadAfriPay";
import animationData from "../../animations/virtualCardAnimation.json";
import { SEO } from '../SEO';
import { FaAngleDown, FaAngleUp, FaRegArrowAltCircleRight } from 'react-icons/fa';
import { motion } from "framer-motion";
import HeroCTA1 from '../HeroCTA1';
import HeroCTA2 from '../HeroCTA2';
import { useDownloadAppModal } from '../../context/DownloadAppModalContext';

function MoneyTransferV3() {
    const { openDownloadModal } = useDownloadAppModal();

    const slideInLeft = {
        hidden: { opacity: 0, x: -80 },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                duration: 0.8,
                ease: "easeOut",
            },
        },
    };

    const slideInRight = {
        hidden: { opacity: 0, x: 80 },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                duration: 0.8,
                ease: "easeOut",
            },
        },
    };

    const container = {
        hidden: {},
        visible: {
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const fadeUp = {
        hidden: {
            opacity: 0,
            y: 40,
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut",
            },
        },
    };

    const fadeUpImage = {
        hidden: { opacity: 0, y: 40, scale: 0.96 },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: { duration: 0.7, ease: "easeOut" },
        },
    };
    return (
        <>

            <SEO
                title="Virtual Card | Afripay"
                description="Get Virtual cards to shop globally on Afripay."
                canonical="https://goafripay.com/virtual-card-page"
            />

            <Navbar />



            {/* Hero Section */}
            <section className='bg-white max-w-7xl mx-auto md:pt-[120px] pb-10'>
                <motion.div
                    style={{
                        backgroundImage: `url(${BannerBg})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                    }}
                    variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}
                    className='flex items-center justify-center lg:justify-between rounded-3xl py-24 lg:py-12 px-10'
                >
                    <motion.div variants={slideInLeft} className='max-w-[512px]'>
                        <h1 className='text-white text-2xl md:text-4xl font-display-fran font-bold mb-1'>Global Cash Transfer in Seconds</h1>
                        <p className='text-white text-base md:text-lg mb-8'>Send money to 50+ countries at lightning speed with transparent fees.</p>
                        <img src="/images/money_calculator.avif" alt="Money Calculator" className='hidden md:block' />
                        <img src="/images/money_calculator_mobile.avif" alt="Money Calculator" className='block md:hidden' />
                        <button className="w-full h-13 p-3.5 text-sm text-white bg-[#0B7F47] border-2 border-[#7FBC51] rounded-xl" onClick={openDownloadModal}>Get started now!</button>
                    </motion.div>
                    <motion.img variants={slideInRight} src="/images/money_hero.avif" alt="Money Transfer" width={400} className='hidden lg:block' />
                </motion.div>
            </section>


            {/* One Account, Global Power */}
            <div className="bg-[#D5EAC9] py-16 px-9 text-center">
                <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className='max-w-7xl mx-auto'>
                    <motion.h2 variants={fadeUp} className='text-3xl text-[#030319] font-display-fran font-bold'>Why AfriPay Transfers</motion.h2>
                    <motion.p variants={fadeUp} className='text-lg text-[#344054] mb-11'>Accepted everywhere Visa is accepted</motion.p>
                    <motion.div variants={fadeUpImage} className='grid grid-cols-2 md:grid-cols-4 gap-4'>
                        <img src="/images/why_transfer1.avif" alt="Instant" />
                        <img src="/images/why_transfer2.avif" alt="Low Fees" />
                        <img src="/images/why_transfer3.avif" alt="Bank-level Security" />
                        <img src="/images/why_transfer4.avif" alt="Track in Real-Time" />
                    </motion.div>
                </motion.div>
            </div>

            <motion.section variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className='bg-white max-w-7xl mx-auto py-16 px-9 flex flex-col items-center text-center'>
                <motion.h2 variants={fadeUp} className='text-3xl text-[#030319] font-display-fran font-bold mb-3'>Why Switch to AfriPay?</motion.h2>
                <motion.p variants={fadeUp} className='text-lg text-[#344054] mb-12'>The best offer you can get</motion.p>
                <motion.div variants={fadeUpImage}>
                    <img src="/images/why_switch.avif" alt="Instant Card Creation" className='lg:max-w-[900px] hidden md:block' />
                    <img src="/images/why_switch_mobile.avif" alt="Instant Card Creation" className='w-full block md:hidden' />
                </motion.div>
            </motion.section>

            {/* FAQ SECTION */}
            <section className="w-full px-4 pt-10 md:pt-20 pb-10">
                <div className="max-w-7xl mx-auto">
                    <div className="w-full flex flex-col md:flex-row items-start md:items-end justify-between mb-8 font-display-fran">
                        <div className="flex flex-col text-left gap-3 mb-4 md:mb-0">
                            <h2 className="text-2xl sm:text-2xl lg:text-4xl text-[#030319] font-display font-bold">
                                Everything You Need to Know
                            </h2>
                            <p className="text-[#344054] text-lg">Discover how AfriPay works and what makes us different</p>
                        </div>
                        <Link to={'/faq'} className="text-[#024529] flex items-center justify-center gap-1.5 cursor-pointer transition-all duration-300 hover:text-gray-600">
                            View All <FaRegArrowAltCircleRight />
                        </Link>
                    </div>
                    <div className="gap-8 lg:mt-16 mt-8 ">
                        <div className="lg:col-span-8 col-span-12">
                            <Accordion allowZeroExpanded allowMultipleExpanded>
                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>What is AfriPay?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            AfriPay is an innovative platform simplifying
                                            international tuition payments, securing educational
                                            loans, and offering a digital wallet feature for
                                            seamless financial transactions.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>How does AfriPay simplify tuition payments?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            AfriPay streamlines the tuition payment process, providing a user-friendly interface and multiple payment options for efficient and secure transactions.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>What security measures does AfriPay have in place?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            AfriPay employs cutting-edge encryption technologies to ensure the security and confidentiality of user data, providing a safe environment for financial transactions.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>What is the digital wallet feature in AfriPay?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            The digital wallet feature allows users to conveniently manage and access funds, enabling cashless transactions, budgeting, and automated savings.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>How does AfriPay support educational loans?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            AfriPay assists users in securing educational loans, streamlining the application process, and providing transparent terms for quick approvals.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                            </Accordion>

                        </div>
                    </div>
                    <div className="w-full flex justify-center pt-5">
                        <button type="button" onClick={openDownloadModal} className="w-[174px] h-13 rounded-lg bg-[#0B7F47] border-2 border-[#7FBC51] shadow-sm text-white text-sm p-3.5 cursor-pointer transition-colors duration-300 hover:bg-[#0B7F47]/60">Get started — it's free</button>
                    </div>
                </div>
            </section>

            <div className='max-w-7xl mx-auto mb-4 lg:mb-8'>
                <HeroCTA1 />
                <HeroCTA2 />
            </div>

            {/* Download AfriPay App */}
            <DownloadAfriPay />

            {/* <-- Footer --> */}
            <Footer />

        </>
    )
}

export default MoneyTransferV3